import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en-US.json';
import nbTranslation from '../locales/nb-NO.json';

const initLanguage = () => {
      i18next
      .use(initReactI18next)
      .init({
            resources: {
                  en: { translation: enTranslation },
                  nb: { translation: nbTranslation }
            },
            lng: 'nb', // default language
            fallbackLng: 'nb', // fallback language
            interpolation: {
                  escapeValue: false
            }
      });
}
export default initLanguage;